import { render, staticRenderFns } from "./RadioButtonGroup.vue?vue&type=template&id=5d0c666c&scoped=true&"
import script from "./RadioButtonGroup.vue?vue&type=script&lang=js&"
export * from "./RadioButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./RadioButtonGroup.vue?vue&type=style&index=0&id=5d0c666c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0c666c",
  null
  
)

export default component.exports